import { ad2bs as e } from "../../../calendar-carburettor/converter/index.js";
import "../../domains/index.js";
// src/design/forms/datepicker/calendar-engine/use-cases/nepali_date/get_normalized_date.ts
var t = e, n = (e, n) => n === "NEPALI" ? e : t(e);
export { n as get_normalized_date };

//# sourceMappingURL=get_normalized_date.js.map